<template lang="pug">
  main
    section.section.is-large
      .container
        .content.has-text-centered
          h1 ⏳ Cargando ... <i class="fa fa-spinner fa-spin" style="font-size:48px"></i>
</template>

<script>
  export default {
    name: 'Loader'
  }
</script>


<style lang="scss" scoped>
  .content {
    padding: 20px;
    min-height: 40vh;
  }
</style>


// WEBPACK FOOTER //
// src/components/shared/Loader.vue